import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackPageOpen } from './tracking';
import { useTrackingParams } from '../../hooks/useTrackingParams';
import { selectPageType } from '../../selectors';
import { EPageType } from '../../types/page/pageType';
import { EScrollingBlocks } from '../../types/page/scrolling';
import { AgentPage } from '../AgentPage';
import { HomeownerPage } from '../HomeownerPage';
import { PromoBannerContainer } from '../PromoBanner';
import { scrollingContext } from '../Scrolling';
import { StickyFooterContainer } from '../StickyFooterContainer';
import { useToggleStickyScrollBtn } from '../StickyFooterContainer/hooks';
import { TabsContainer } from '../Tabs';
import { TenantPage } from '../TenantPage';

export const PageContainer: React.FC = () => {
  const pageType = useSelector(selectPageType);
  const { siteType, dealType, cianSource } = useTrackingParams();

  const mainButtonsRef = React.useRef<HTMLDivElement>(null);
  const howItWorkRef = React.useRef<HTMLDivElement>(null);
  const { setRefBlocksState } = React.useContext(scrollingContext);

  useToggleStickyScrollBtn(mainButtonsRef);

  React.useEffect(() => {
    trackPageOpen({
      siteType,
      dealType,
      cianSource,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType]);

  React.useEffect(() => {
    setRefBlocksState(prevState => {
      return {
        ...prevState,
        [EScrollingBlocks.HowItWork]: {
          id: EScrollingBlocks.HowItWork,
          ref: howItWorkRef,
        },
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (pageType === EPageType.Agent) {
    return <AgentPage mainButtonsRef={mainButtonsRef} />;
  }

  return (
    <>
      <PromoBannerContainer mainButtonsRef={mainButtonsRef} />
      <TabsContainer />
      {pageType === EPageType.Homeowner && <HomeownerPage howItWorkRef={howItWorkRef} />}
      {pageType === EPageType.Tenant && <TenantPage howItWorkRef={howItWorkRef} />}
      <StickyFooterContainer />
    </>
  );
};
